export const DEFAULT_DATE_FORMAT = 'MMDDYYYY';
export const FALLBACK_DATE_FORMAT = 'MMDDYY';
export const DATE_FORMAT = [DEFAULT_DATE_FORMAT, FALLBACK_DATE_FORMAT];
